module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_135046-1113514711.06c11ef7.jpg";